export default __webpack_public_path__ + "static/media/searchFilterIcon.fa4864cd.svg";